import { render } from "./UniProducto.vue?vue&type=template&id=046ee335&scoped=true"
import script from "./UniProducto.vue?vue&type=script&lang=js"
export * from "./UniProducto.vue?vue&type=script&lang=js"

import "./UniProducto.vue?vue&type=style&index=0&id=046ee335&lang=scss&scoped=true"

import exportComponent from "/Users/anfloman/Desktop/ComponentesAlgoritmica/TemaWordpress/tema/vuejs/ParrillaPrecios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046ee335"]])

export default __exports__